import { Medicament } from "./medicament";
import { Ordonnance } from "./ordonnance";
export class Prescription {
	prescription_id : number;
	prescription_quantite : number;
	medicament_id : number;
	ordonnance_id : number;
	prescription_observation : String;
	prescription_modalite : String;
	prescription_dose : String;
	prescription_etat  : String;
	prescription_duree : String;
	prescription_presentation : String;
    medicament : Medicament;
    prescription_medicament_lib : String;
    prescription_externe : number;
    medicament_libelle:String;
    prescription_dose_temp : String;
    prescription_unite_quantite : String;
    categorie_id :number;
    ordonnance : Ordonnance;
    petit_client_id : String;
    strDate : String;
	constructor(){
		
	}

}
